import { gql } from "@apollo/client";

export const getAllProducts = gql`
  query {
    allProducts {
      success

      error

      message

      data {
        id

        productCode

        productName
      }
    }
  }
`;

export const unassignedSalesOrders = gql`
  query {
    unassignedSalesOrders {
      success
      message
      data {
        id
        orderSio
      }
    }
  }
`;

export const unassignedSalesOrdersById = gql`
  query UnassignedSalesOrdersById($id: Int!) {
    unassignedSalesOrdersById(id: $id) {
      success
      message
      data {
        id
        orderSio
        customerName
        customerAddress
        contactPerson
        deliveryDate
        totalAmount
        status
        role
        products {
          productName
          quantity
          price
          amount
        }
      }
    }
  }
`;

//Create Delivery
export const createDeliveryMutation = gql`
  mutation CreateDelivery($input: CreateDeliveryInput!) {
    createDelivery(input: $input) {
      success
      message
      deliveryId
    }
  }
`;

//Update Delivery
export const updateDeliveryMutation = gql`
  mutation UpdateDelivery($input: UpdateDeliveryInput!) {
    updateDelivery(input: $input) {
      success
      message
    }
  }
`;

//All delivery Employees
export const allDeliveries = gql`
  query {
    allUsers {
      id
      employeeName
      employeeCode
      role {
        id
        role
      }
      department
      createdAt
      isActive
    }
  }
`;

//Delivery List
export const allDeliveryList = gql`
  query GetAllDeliveries($page: Int, $pageSize: Int, $search: String) {
    allDeliveries(page: $page, pageSize: $pageSize, search: $search) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      data {
        id
        deliveryId
        salesOrder {
          id
        }
        repName
        repCode
        customerName
        customerAddress
        typeOfCreation
        deliveryStatus
        visitStatus
        deliveredDate
        deliveredOn
        reason
        contactPerson
        contactNumber
        paymentMode
        user {
          firstName
          lastName
          employeeName
        }
        createdAt
        updatedAt
        deliveryProducts {
          id
          productCode
          productName
          quantity
          createdAt
          updatedAt
        }
        deliverypersoncheckinSet {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }
        deliverypersoncheckoutSet {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          visitDate
        }
      }
    }
  }
`;

//Get Delivery By ID
export const getDeliveryById = gql`
  query GetDeliveryById($id: ID!) {
    getDeliveryById(id: $id) {
      success
      error
      message
      data {
        id
        repCode
        repName
        repRole
        deliveryStatus
        deliveryId
        customerName
        customerAddress
        contactPerson
        contactNumber
        deliveredDate
        deliveryStatus
        deliveredOn
        paymentMode
        createdAt
        reason
        signature
        salesOrder {
          id
          orderDate
          totalAmount
          soNumber
          sio
        }
        deliveryProducts {
          productName
          productCode
          quantity
          id
        }
      }
    }
  }
`;

//Delete delivery
export const deleteDelivery = gql`
  mutation DeleteDelivery($deliveryId: ID!) {
    deleteDelivery(deliveryId: $deliveryId) {
      success
      error
      message
    }
  }
`;

//Bulk Upload
export const bulkUpload = gql`
  mutation UploadDelivery($file: Upload!, $userid: Int!) {
    uploadDeliveryExcel(userId: $userid, file: $file) {
      success
      message
    }
  }
`;

//Past Deliveries List
export const pastDeliveriesListQuery = gql`
  query GetPastDeliveries(
    $page: Int
    $pageSize: Int
    $search: String
    $startDate: Date
    $endDate: Date
    $agentId: Int
  ) {
    pastDeliveries(
      page: $page
      pageSize: $pageSize
      search: $search
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
    ) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        deliveryId
        createdAt
        salesOrder {
          id
          soNumber
        }
        repName
        repCode
        customerName
        customerAddress
        typeOfCreation
        deliveryStatus
        visitStatus
        deliveredDate
        deliveredOn
        reason
        contactPerson
        contactNumber
        paymentMode
        user {
          firstName
          lastName
          employeeName
        }
        createdAt
        updatedAt
        deliveryProducts {
          id
          productCode
          productName
          quantity
          createdAt
          updatedAt
        }
        deliverypersoncheckinSet {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }
        deliverypersoncheckoutSet {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          visitDate
        }
      }
    }
  }
`;

export const completedDeliveries = gql`
  query CompletedDeliveries(
    $page: Int
    $pageSize: Int
    $search: String
    $startDate: Date
    $endDate: Date
    $agentId: Int
  ) {
    completedDeliveries(
      page: $page
      pageSize: $pageSize
      search: $search
      startDate: $startDate
      endDate: $endDate
      agentId: $agentId
    ) {
      success
      message
      totalCount
      totalPages
      currentPage
      data {
        id
        deliveryId
        salesOrder {
          id
        }
        repName
        repCode
        customerName
        customerAddress
        typeOfCreation
        deliveryStatus
        visitStatus
        deliveredDate
        deliveredOn
        reason
        contactPerson
        contactNumber
        paymentMode
        user {
          firstName
          lastName
          employeeName
        }
        createdAt
        updatedAt
        deliveryProducts {
          id
          productCode
          productName
          quantity
          createdAt
          updatedAt
        }
        deliverypersoncheckinSet {
          id
          checkInTime
          checkinLocationLat
          checkinLocationLng
          visitDate
        }
        deliverypersoncheckoutSet {
          id
          checkOutTime
          checkoutLocationLat
          checkoutLocationLng
          duration
          visitDate
        }
      }
    }
  }
`;
